/* Product galleries and quantity rules. Cart transport stays in seoul-root-commerce.js. */
(function (scope) {
  'use strict';
  function nextQuantity(value, direction, minimum, increment, maximum) {
    const min = Number(minimum) || 1;
    const step = Number(increment) || 1;
    const max = Number(maximum) > 0 ? Number(maximum) : Infinity;
    const current = Number.isFinite(Number(value)) ? Number(value) : min;
    const aligned = min + Math.round((current - min) / step) * step;
    const upper = Number.isFinite(max) ? min + Math.floor((max - min) / step) * step : max;
    return Math.max(min, Math.min(upper, aligned + direction * step));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { nextQuantity };
  if (!scope.document || scope.SeoulRootProductLoaded) return;
  scope.SeoulRootProductLoaded = true;
  function initialize(container) {
    container.querySelectorAll('[data-sr-product-page]').forEach(root => {
      if (root.dataset.srInitialized) return;
      root.dataset.srInitialized = 'true';
      const thumbs = Array.from(root.querySelectorAll('[data-sr-gallery-thumb]'));
      let index = Math.max(0, thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
      function showImage(next) {
        if (!thumbs.length) return;
        index = (next + thumbs.length) % thumbs.length;
        const button = thumbs[index];
        const main = root.querySelector('[data-sr-main-image]');
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = button.dataset.imageSrc;
        main.alt = button.dataset.imageAlt;
        const zoom = root.querySelector('[data-sr-image-zoom]');
        if (zoom) zoom.href = button.dataset.imageZoom;
        root.querySelector('[data-sr-gallery-stage]').dataset.photograph = button.dataset.imagePhotograph;
        thumbs.forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
        root.querySelector('[data-sr-gallery-status]').textContent = 'Image ' + (index + 1) + ' of ' + thumbs.length;
      }
      thumbs.forEach((button,i) => button.addEventListener('click', () => showImage(i)));
      root.querySelector('[data-sr-gallery-prev]')?.addEventListener('click', () => showImage(index - 1));
      root.querySelector('[data-sr-gallery-next]')?.addEventListener('click', () => showImage(index + 1));
      const quantity = root.querySelector('[name="quantity"]');
      const minus = root.querySelector('[data-sr-product-quantity="-1"]');
      const plus = root.querySelector('[data-sr-product-quantity="1"]');
      function controls() {
        minus.disabled = Number(quantity.value) <= Number(quantity.min);
        plus.disabled = !!quantity.max && Number(quantity.value) + Number(quantity.step) > Number(quantity.max);
      }
      [minus,plus].forEach(button => button.addEventListener('click', () => {
        quantity.value = nextQuantity(quantity.value,Number(button.dataset.srProductQuantity),quantity.min,quantity.step,quantity.max);
        controls();
      }));
      quantity.addEventListener('input', controls);
      const select = root.querySelector('[data-sr-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        root.querySelector('[data-sr-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-sr-compare-price]');
        compare.textContent = option.dataset.comparePrice;
        compare.hidden = !option.dataset.comparePrice;
        quantity.min = option.dataset.minimum || 1;
        quantity.step = option.dataset.increment || 1;
        if (option.dataset.maximum) quantity.max = option.dataset.maximum;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const submit = root.querySelector('[data-sr-product-submit]');
        submit.disabled = option.dataset.available !== 'true';
        submit.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
        const imageIndex = thumbs.findIndex(b => b.dataset.imageId === option.dataset.imageId);
        if (imageIndex >= 0) showImage(imageIndex);
        const url = new URL(scope.location.href);
        url.searchParams.set('variant',option.value);
        scope.history.replaceState({},'',url);
        controls();
      });
      controls();
    });
  }
  initialize(scope.document);
  scope.document.addEventListener('shopify:section:load',event => initialize(event.target));
})(typeof window === 'undefined' ? {} : window);
